import { render, staticRenderFns } from "./AccountHolderExpenseEvidence.vue?vue&type=template&id=be1ae564&scoped=true"
import script from "./AccountHolderExpenseEvidence.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseEvidence.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExpenseEvidence.vue?vue&type=style&index=0&id=be1ae564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1ae564",
  null
  
)

export default component.exports